import { ArticleJsonLD, BreadCrumbJsonLD } from './json-ld';
import { ArticlePreload } from '@article/head/preload';
import { FC } from 'react';
import { ArticleRobots } from '@article/head/rebots';
import { SmartBannerMeta } from '~/routes/$user_link_name_.$article_id/body/smart-banner';
import { SharingCardMeta } from './sharing-card';

export const ArticleHead: FC = () => {
  return (
    <>
      <SmartBannerMeta />
      <SharingCardMeta />
      <ArticleRobots />
      <ArticlePreload />
      <BreadCrumbJsonLD />
      <ArticleJsonLD />
    </>
  );
};
